import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { useParams } from "react-router-dom";
import ChannelDetailPage from "./ChannelDetailPage";
import { FETCH_TEAMS_SUBSCRIPTIONS } from "./graphql";

const SubscriptionDetailLoader = () => {
  const { teamId: encodedTeamId, channelId: encodedChannelId } = useParams();
  const teamId = decodeURIComponent(encodedTeamId);
  const channelId = decodeURIComponent(encodedChannelId);
  const { data, loading, error } = useQuery(FETCH_TEAMS_SUBSCRIPTIONS, {
    variables: { teamId, channelId, includeRemoved: false, limit: 50 },
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <ChannelDetailPage
      teamId={teamId}
      channelId={channelId}
      subscription={data?.teamsSubscriptions?.[0]}
    />
  );
};

export default SubscriptionDetailLoader;
